module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("T")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("o all the right-thinking men I have known,")]), _vm._v(" "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("and the libertines who keep them in line.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d809869","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HouseDivided-6.vue
// module id = 75
// module chunks = 0